import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import { ERouterName } from "/@/types/index";
import CreatePlan from "/@/components/task/CreatePlan.vue";
import WaylinePanelTask from "/@/pages/page-web/projects/waylinetask.vue";
import DockPanel from "/@/pages/page-web/projects/dock.vue";
// @ts-ignore
import nProgress from "nprogress";
import "nprogress/nprogress.css";
const basePath = "/";
// const basePath = '/jjwrj/' //路由公共部分
const routes: Array<RouteRecordRaw> = [
  {
    path: basePath,
    redirect: basePath + ERouterName.PROJECT,
  },
  // 首页
  {
    path: basePath + ERouterName.PROJECT,
    name: ERouterName.PROJECT,
    component: () => import("/@/pages/page-web/index.vue"),
  },
  // 总控 无人机监测
  {
    path: basePath + "zkfly",
    name: "zkfly",
    component: () => import("/@/pages/page-web/zkfly.vue"),
  },
  // 总控 无人机监测app
  {
    path: basePath + "zkApp",
    name: "zkApp",
    component: () => import("/@/pages/page-web/zkApp.vue"),
  },
  // 分享直播
  {
    path: basePath + "webrtcplay",
    name: "webrtcplay",
    component: () => import("/@/pages/page-web/projects/webrtcplay.vue"),
  },
  // 单点登录
  {
    path: "/" + "single",
    name: "single",
    component: () => import("/@/pages/page-web/single.vue"),
  },
  // token登录
  {
    path: "/" + "singlelogin",
    name: "singlelogin",
    component: () => import("/@/pages/page-web/singlelogin.vue"),
  },
  // 组织
  {
    path: basePath + "organization",
    name: "organization",
    component: () =>
      import("/@/pages/page-web/projects/organization/organization.vue"),
  },
  // 我的组织
  {
    path: basePath + "myorganization",
    name: "myorganization",
    component: () =>
      import("/@/pages/page-web/projects/myorganization/myorganization.vue"),
  },
  // 进入页面
  {
    path: basePath + "enterpage",
    name: "enterpage",
    component: () => import("/@/pages/page-web/projects/enterpage/index.vue"),
  },
  // 御4 飞行控制页面
  {
    path: "/drviceAircraft",
    name: "drviceAircraft",
    component: () =>
      import("/@/pages/page-web/projects/drviceAircraft/index.vue"),
  },
  // members, devices，FIRMWARES
  {
    path: basePath + ERouterName.HOME,
    name: ERouterName.HOME,
    component: () => import("/@/pages/page-web/home.vue"),
    children: [
      {
        path: basePath + ERouterName.MEMBERS,
        name: ERouterName.MEMBERS,
        component: () => import("/@/pages/page-web/projects/members.vue"),
      },
      {
        path: basePath + ERouterName.DEVICES,
        name: ERouterName.DEVICES,
        component: () => import("/@/pages/page-web/projects/devices.vue"),
      },
      {
        path: basePath + ERouterName.FIRMWARES,
        name: ERouterName.FIRMWARES,
        component: () => import("../pages/page-web/projects/Firmwares.vue"),
      },
      {
        path: basePath + ERouterName.LIVESTREAM,
        name: ERouterName.LIVESTREAM,
        component: () => import("/@/pages/page-web/projects/livestream.vue"),
        // children: [
        //   {
        //     path: ERouterName.LIVING,
        //     name: ERouterName.LIVING,
        //     components: {
        //       LiveAgora,
        //       LiveOthers
        //     }
        //   }
        // ]
      },
      {
        path: basePath + ERouterName.TSA,
        name: ERouterName.TSA,
        component: () => import("/@/pages/page-web/projects/tsa.vue"),
      },
      {
        path: basePath + "vediomap",
        name: "vediomap",
        component: () =>
          import("/@/pages/page-web/projects/vedioMap/vedioMap.vue"),
      },
      {
        path: basePath + "vediomapzk",
        name: "vediomapzk",
        component: () =>
          import("/@/pages/page-web/projects/vedioMapZk/vedioMap.vue"),
      },
      // app-分配监测
      {
        path: basePath + "videoZkApp",
        name: "videoZkApp",
        component: () =>
          import("/@/pages/page-web/projects/videoZkApp/vedioMap.vue"),
      },
      // app-空气监测
      {
        path: basePath + "gridmapApp",
        name: "gridmapApp",
        component: () => import("/@/pages/page-web/projects/gridmapApp.vue"),
      },
      // 总控-空气监测
      {
        path: basePath + "gridmapzk",
        name: "gridmapzk",
        component: () => import("/@/pages/page-web/projects/gridmapzk.vue"),
      },
      // app-媒体文件
      {
        path: basePath + "mediaApp",
        name: "mediaApp",
        component: () => import("/@/components/mediaApp.vue"),
      },
      // app-任务
      {
        path: basePath + "taskApp",
        name: "taskApp",
        component: () => import("/@/pages/page-web/projects/taskApp.vue"),
      },
      {
        path: basePath + ERouterName.LAYER,
        name: ERouterName.LAYER,
        component: () => import("/@/pages/page-web/projects/layer.vue"),
      },
      {
        path: basePath + ERouterName.MEDIA,
        name: ERouterName.MEDIA,
        component: () => import("/@/components/MediaPanel.vue"),
      },
      // 媒体文件
      {
        path: basePath + "file",
        name: "file",
        component: () => import("/@/components/MediaPanelFile.vue"),
      },
      {
        path: basePath + ERouterName.WAYLINE,
        name: ERouterName.WAYLINE,
        component: () => import("/@/pages/page-web/projects/wayline.vue"),
      },
      {
        path: basePath + ERouterName.TASK,
        name: ERouterName.TASK,
        component: () => import("/@/pages/page-web/projects/task.vue"),
        children: [
          {
            path: ERouterName.CREATE_PLAN,
            name: ERouterName.CREATE_PLAN,
            component: CreatePlan,
            children: [
              {
                path: ERouterName.SELECT_PLAN,
                name: ERouterName.SELECT_PLAN,
                components: {
                  WaylinePanelTask,
                  DockPanel,
                },
              },
            ],
          },
        ],
      },
      {
        path: basePath + "grid", //网格
        name: "grid",
        component: () => import("/@/pages/page-web/projects/gridmap.vue"),
      },
      {
        path: basePath + "buildsite", //工地
        name: "buildsite",
        component: () =>
          import("/@/pages/page-web/projects/buildSite/buildSite.vue"),
      },
      {
        path: basePath + "template", //动作模板
        name: "template",
        component: () =>
          import("/@/pages/page-web/projects/template/template.vue"),
      },
      {
        path: basePath + "livevedio", //视频
        name: "livevedio",
        component: () =>
          import("/@/pages/page-web/projects/liveVedio/live.vue"),
      },
      {
        path: basePath + "roles",
        name: "roles",
        component: () => import("/@/pages/page-web/projects/roles/roles.vue"),
      },
      {
        path: basePath + "rtmp",
        name: "rtmp",
        component: () =>
          import("/@/pages/page-web/projects/rtmplist/rtmplist.vue"),
      },
      {
        path: basePath + "fireworks",
        name: "fireworks",
        component: () =>
          import("/@/pages/page-web/projects/fireworks/fireworks.vue"),
      },
      // ai智能识别
      {
        path: "/imgport",
        name: "imgport",
        component: () =>
          import("/@/pages/page-web/projects/imgport/imglist.vue"),
      },
      // ai智能识别
      {
        path: "/warnevent",
        name: "warnevent",
        component: () =>
          import("/@/pages/page-web/projects/warnEvent/warn.vue"),
      },
      // ai 工厂
      {
        path: "/aiFactory",
        name: "aiFactory",
        component: () =>
          import("/@/pages/page-web/projects/aiFactory/index.vue"),
      },
      // ai离线视频
      {
        path: "/aiVideoOut",
        name: "aiVideoOut",
        component: () => import("/@/pages/page-web/projects/aiLog/index.vue"),
      },
      // 区域设置
      {
        path: "/regiondraw",
        name: "regiondraw",
        component: () =>
          import("/@/pages/page-web/projects/regionDraw/region.vue"),
      },
      // 时空gis
      {
        path: "/regionGis",
        name: "regionGis",
        component: () =>
          import("/@/pages/page-web/projects/regionGis/index.vue"),
      },
      // 时空gis管理页面
      {
        path: "/manageGis",
        name: "manageGis",
        component: () =>
          import("/@/pages/page-web/projects/manageGis/index.vue"),
      },
      // ai 筛查
      {
        path: "/aiCompare",
        name: "aiCompare",
        component: () =>
          import("/@/pages/page-web/projects/aiCompare/index.vue"),
      },
      // 作业管理
      {
        path: "/jobRegion",
        name: "jobRegion",
        component: () =>
          import("/@/pages/page-web/projects/jobRegion/index.vue"),
      },
      // 基桩管理
      {
        path: "/foundation",
        name: "foundation",
        component: () =>
          import("/@/pages/page-web/projects/foundation/index.vue"),
      },
      // 温度告警
      {
        path: "/temperatureWarn",
        name: "temperatureWarn",
        component: () =>
          import("/@/pages/page-web/projects/temperatureWarn/index.vue"),
      },
      // ai 流地址
      {
        path: "/aiflow",
        name: "aiflow",
        component: () => import("/@/pages/page-web/projects/aiflow/index.vue"),
      },
      // ai 模型文件
      {
        path: "/aimodel",
        name: "aimodel",
        component: () => import("/@/pages/page-web/projects/aiModel/index.vue"),
      },
      // 设备模型文件
      {
        path: "/sysModelfile",
        name: "sysModelfile",
        component: () => import("/@/pages/page-web/projects/sysModelfile/index.vue"),
      },
      // 设备模型文件
      // {
      //   path: "/msControl",
      //   name: "msControl",
      //   component: () => import("/@/pages/page-web/projects/msControl/index.vue"),
      // },
      // ai 执行文件
      {
        path: "/aiexcute",
        name: "aiexcute",
        component: () =>
          import("/@/pages/page-web/projects/aiExecute/index.vue"),
      },
      // 大屏
      {
        path: "/largescreen",
        name: "largescreen",
        component: () =>
          import("/@/pages/page-web/projects/largeScreen/index.vue"),
      },
      // ai算法库
      {
        path: "/aiaLgorithm",
        name: "aiaLgorithm",
        component: () =>
          import("/@/pages/page-web/projects/AiaLgorithm/index.vue"),
      },
      // ai识别
      {
        path: "/riverAi",
        name: "riverAi",
        component: () =>
          import("/@/pages/page-web/projects/recognitionAi/index.vue"),
      },
      // 3d gs
      {
        path: "/aigs",
        name: "aigs",
        component: () => import("/@/pages/page-web/projects/aiGs/index.vue"),
      },
      // AI短信推送管理
      {
        path: "/aipush",
        name: "aipush",
        component: () =>
          import("/@/pages/page-web/projects/pushManage/index.vue"),
      },
      // AI配置管理
      {
        path: "/aiConfig",
        name: "aiConfig",
        component: () =>
          import("/@/pages/page-web/projects/configManage/index.vue"),
      },
      // AI规则管理
      {
        path: "/aiRules",
        name: "aiRules",
        component: () =>
          import("/@/pages/page-web/projects/rulesManage/index.vue"),
      },
      // 报告管理
      {
        path: "/aireport",
        name: "aireport",
        component: () =>
          import("/@/pages/page-web/projects/report/index.vue"),
      },
      // 航线总览
      {
        path: "/waylinetotal",
        name: "waylinetotal",
        component: () =>
          import("/@/pages/page-web/projects/waylineTotal/index.vue"),
      },
      // 数据字典
      {
        path: "/dictionary",
        name: "dictionary",
        component: () =>
          import("/@/pages/page-web/projects/dictionary/index.vue"),
      },
      // 空气设备
      {
        path: "/statisticsLog",
        name: "statisticsLog",
        component: () =>
          import("/@/pages/page-web/projects/statisticsLog/index.vue"),
      },
      // 多光谱
      {
        path: "/multispectral",
        name: "multispectral",
        component: () =>
          import("/@/pages/page-web/projects/multispectral/index.vue"),
      },
      // 气象数据
      {
        path: "/metedata",
        name: "metedata",
        component: () =>
          import("/@/pages/page-web/projects/metedata/index.vue"),
      },
      // 内嵌
      {
        path: "/iframe",
        name: "iframe",
        component: () =>
          import("/@/pages/page-web/projects/iframe/index.vue"),
      },
      // 模型管理
      {
        path: "/modelbase",
        name: "modelbase",
        component: () =>
          import("/@/pages/page-web/projects/sysModel/model.vue"),
      },
      // ai智图
      {
        path: "/modelImage",
        name: "modelImage",
        component: () =>
          import("/@/pages/page-web/projects/modelImage/index.vue"),
      },
      // shaper管理
      {
        path: "/shaper",
        name: "shaper",
        component: () =>
          import("/@/pages/page-web/projects/shaperManage/shaper.vue"),
      },
      {
        path: basePath + "arcface",
        name: "arcface",
        component: () =>
          import("/@/pages/page-web/projects/arcface/arcface.vue"),
      },
      {
        path: basePath + "facelog",
        name: "facelog",
        component: () =>
          import("/@/pages/page-web/projects/arcface/facelog.vue"),
      },
      {
        path: basePath + "humanrecog",
        name: "humanrecog",
        component: () =>
          import("/@/pages/page-web/projects/humanrecog/humanrecog.vue"),
      },
      {
        path: basePath + "shout",
        name: "shout",
        component: () => import("/@/pages/page-web/projects/shout/shout.vue"),
      },
      {
        path: basePath + "work",
        name: "work",
        component: () =>
          import("/@/pages/page-web/projects/works/workspaces.vue"),
      },
      {
        path: basePath + "markmap", //飞行配置
        name: "markmap",
        component: () => import("/@/components/markMap.vue"),
      },
      {
        path: basePath + "sysset", //系统设置
        name: "sysset",
        component: () => import("/@/pages/page-web/projects/sysSet/sysSet.vue"),
      },
      {
        path: basePath + "annotation", // 垃圾点位管理
        name: "annotation",
        component: () =>
          import("/@/pages/page-web/projects/annotation/index.vue"),
      },
      {
        path: basePath + "reportModule", // 报告模块管理
        name: "reportModule",
        component: () =>
          import("/@/pages/page-web/projects/reportModule/index.vue"),
      },
      {
        path: basePath + "reportConfig", // 报告模板配置
        name: "reportConfig",
        component: () =>
          import("/@/pages/page-web/projects/reportConfig/index.vue"),
      },
      {
        path: basePath + "reportprompt", // 提示词管理
        name: "reportprompt",
        component: () =>
          import("/@/pages/page-web/projects/reportprompt/index.vue"),
      },
      {
        path: basePath + "windweather", // 风场气象
        name: "windweather",
        component: () =>
          import("/@/pages/page-web/projects/windweather/index.vue"),
      },
      {
        path: basePath + "menuManage", // 菜单管理
        name: "menuManage",
        component: () =>
          import("/@/pages/page-web/projects/menuManage/menu.vue"),
      },
    ],
  },
  // workspace
  // {
  //   path: '/' + ERouterName.WORKSPACE,
  //   name: ERouterName.WORKSPACE,
  //   component: () => import('/@/pages/page-web/projects/workspace.vue'),
  //   redirect: '/' + ERouterName.TSA,
  //   children: [
  //     {
  //       path: '/' + ERouterName.LIVESTREAM,
  //       name: ERouterName.LIVESTREAM,
  //       component: () => import('/@/pages/page-web/projects/livestream.vue'),
  //       children: [
  //         {
  //           path: ERouterName.LIVING,
  //           name: ERouterName.LIVING,
  //           components: {
  //             LiveAgora,
  //             LiveOthers
  //           }
  //         }
  //       ]
  //     },
  //     {
  //       path: '/' + ERouterName.TSA,
  //       component: () => import('/@/pages/page-web/projects/tsa.vue')
  //     },
  //     {
  //       path: '/' + ERouterName.LAYER,
  //       name: ERouterName.LAYER,
  //       component: () => import('/@/pages/page-web/projects/layer.vue')
  //     },
  //     {
  //       path: '/' + ERouterName.MEDIA,
  //       name: ERouterName.MEDIA,
  //       component: () => import('/@/pages/page-web/projects/media.vue')
  //     },
  //     {
  //       path: '/' + ERouterName.WAYLINE,
  //       name: ERouterName.WAYLINE,
  //       component: () => import('/@/pages/page-web/projects/wayline.vue')
  //     },
  //     {
  //       path: '/' + ERouterName.TASK,
  //       name: ERouterName.TASK,
  //       component: () => import('/@/pages/page-web/projects/task.vue'),
  //       children: [
  //         {
  //           path: ERouterName.CREATE_PLAN,
  //           name: ERouterName.CREATE_PLAN,
  //           component: CreatePlan,
  //           children: [
  //             {
  //               path: ERouterName.SELECT_PLAN,
  //               name: ERouterName.SELECT_PLAN,
  //               components: {
  //                 WaylinePanel,
  //                 DockPanel
  //               }
  //             }
  //           ]
  //         }

  //       ]
  //     }
  //   ]
  // },
  // pilot
  {
    path: basePath + ERouterName.PILOT,
    name: ERouterName.PILOT,
    component: () => import("/@/pages/page-pilot/pilot-index.vue"),
  },
  {
    path: basePath + ERouterName.PILOT_HOME,
    component: () => import("/@/pages/page-pilot/pilot-home.vue"),
  },
  {
    path: basePath + ERouterName.PILOT_MEDIA,
    component: () => import("/@/pages/page-pilot/pilot-media.vue"),
  },
  {
    path: basePath + ERouterName.PILOT_LIVESHARE,
    component: () => import("/@/pages/page-pilot/pilot-liveshare.vue"),
  },
  {
    path: basePath + ERouterName.PILOT_BIND,
    component: () => import("/@/pages/page-pilot/pilot-bind.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});
// 配置NProgress
nProgress.configure({
  showSpinner: false,
  easing: "ease",
  speed: 500,
});
// 全局前置守卫
router.beforeEach((to, from, next) => {
  // 开始加载进度条
  nProgress.start();
  next();
});

// 全局后置钩子
router.afterEach(() => {
  // 完成加载进度条
  nProgress.done();
});

export default router;
